
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(464|585)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
